import { CSSTransition } from 'react-transition-group';

import { useHookstate } from '@hookstate/core';
import React, { useState, useContext } from 'react';
import { useNavigationState } from '@store/hookstate';

import { NavigationContext } from '@layout/navigation/navigation';
import GlobalOverlay from '@components/GlobalOverlay';
import { SidebarItem } from '@components/SidebarItem/SidebarItem';
import { useSelector } from 'react-redux';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { useClickOutside } from '@mantine/hooks';
import { ProfileContent } from './components';

import { ProfileImg, Block, StyledAvatarPlaceholder } from './Profile.styles';

const Profile = () => {
  const open = useHookstate(false);
  const navigationState = useNavigationState();
  const handleClickAway = () => {
    if (open.value) open.set(false);
  };
  const [contentRef, setContent] = useState<HTMLDivElement | null>(null);

  function getElements() {
    const els: HTMLElement[] = [];
    if (contentRef) els.push(contentRef);
    return els;
  }
  // NOTE do not use with blur or other events without a "target" as it will throw.
  useClickOutside(handleClickAway, [], getElements());
  const { userName, userPicture, userId } = useContext(NavigationContext);

  const { isMobile } = useSelector(checkDevice());

  function handleClick() {
    return () => {
      return open.set(!open.get());
    };
  }
  function handleClickMobile() {
    return () => {
      navigationState.navigationTab.set('accounts');
    };
  }

  return (
    <>
      <SidebarItem
        label={isMobile ? 'Account' : userName}
        onClick={isMobile ? handleClickMobile() : handleClick()}
        iconImage={
          <ProfileImg
            src={userPicture}
            brokenSrc={<StyledAvatarPlaceholder />}
            alt=""
          />
        }
      />

      <CSSTransition
        in={open.get()}
        timeout={300}
        classNames="my-node"
        unmountOnExit
        onEnter={() => open.set(true)}
        onExited={() => open.set(false)}
      >
        <Block
          width={
            navigationState.sidebarOpen.get()
              ? navigationState.maxLeft.get()
              : navigationState.minLeft.get()
          }
          ref={setContent}
        >
          {open && <GlobalOverlay onClick={handleClickAway} />}
          <ProfileContent
            openAddField={open}
            userName={userName}
            userPicture={userPicture}
            userId={userId}
          />
        </Block>
      </CSSTransition>
    </>
  );
};

export { Profile };
